// const primary = '#f4b741'
const primary = 'var(--kt-primary)'
const secondary = 'var(--kt-secondary-active)'
const info = 'var(--kt-info-light)'
const warning = 'var(--kt-warning)'
const danger = 'var(--kt-danger)'

export const trendColors = [
  // https://coolors.co/f4b741-5e5b52-cee5f2-accbe1-de541e
  primary,
  secondary,
  // '#CEE5F2',
  warning,
  // '#ACCBE1',
  info,
  // '#DE541E'
  danger
]

export const segmentsColors = [
  // https://coolors.co/f4b741-5e5b52-cee5f2-accbe1-de541e
  primary,
  secondary,
  // '#ACCBE1',
  info,
  // '#DE541E',
  danger,
  // '#CEE5F2'
  warning
]

export const primaryColor = primary
